import { ref } from 'vue'

export function useTooltip(options?: { width?: number; height?: number; hideDelay?: number }) {
  const hoveredTooltipText = ref('')
  const showTooltip = ref(false)
  const tooltipX = ref(0)
  const tooltipY = ref(0)
  let tooltipHideTimer: ReturnType<typeof setTimeout> | null = null

  const defaultWidth = options?.width ?? 480
  const defaultHeight = options?.height ?? 80
  const hideDelay = options?.hideDelay ?? 0

  const handleTooltipMouseMove = (e: MouseEvent) => {
    if (tooltipHideTimer !== null) return

    let x = e.clientX + 12
    let y = e.clientY + 16

    const tooltipEl = document.querySelector('.text-tooltip-container') as HTMLElement | null
    const actualWidth = tooltipEl?.offsetWidth || defaultWidth
    const actualHeight = tooltipEl?.offsetHeight || defaultHeight

    if (x + actualWidth > window.innerWidth - 12) {
      x = e.clientX - actualWidth - 12
    }
    if (x < 12) {
      x = 12
    }

    if (y + actualHeight > window.innerHeight - 12) {
      y = e.clientY - actualHeight - 16
    }
    if (y < 12) {
      y = 12
    }

    tooltipX.value = x
    tooltipY.value = y
  }

  const handleTextMouseEnter = (e: MouseEvent, fullText: string, force = false) => {
    if (tooltipHideTimer) {
      clearTimeout(tooltipHideTimer)
      tooltipHideTimer = null
    }
    const target = e.currentTarget as HTMLElement
    if (target) {
      const isOverflowing = force || target.scrollWidth > target.offsetWidth || target.scrollHeight > target.offsetHeight
      if (isOverflowing && fullText) {
        hoveredTooltipText.value = fullText
        showTooltip.value = true
        handleTooltipMouseMove(e)
      }
    }
  }

  const handleTextMouseLeave = () => {
    if (tooltipHideTimer) {
      clearTimeout(tooltipHideTimer)
      tooltipHideTimer = null
    }
    if (hideDelay === 0) {
      showTooltip.value = false
      hoveredTooltipText.value = ''
      return
    }
    tooltipHideTimer = setTimeout(() => {
      showTooltip.value = false
      hoveredTooltipText.value = ''
      tooltipHideTimer = null
    }, hideDelay)
  }

  const handleTooltipMouseEnter = () => {
    if (tooltipHideTimer) {
      clearTimeout(tooltipHideTimer)
      tooltipHideTimer = null
    }
  }

  const handleTooltipMouseLeave = () => {
    showTooltip.value = false
    hoveredTooltipText.value = ''
    if (tooltipHideTimer) {
      clearTimeout(tooltipHideTimer)
      tooltipHideTimer = null
    }
  }

  return {
    hoveredTooltipText,
    showTooltip,
    tooltipX,
    tooltipY,
    handleTooltipMouseMove,
    handleTextMouseEnter,
    handleTextMouseLeave,
    handleTooltipMouseEnter,
    handleTooltipMouseLeave,
    // 호환용 alias
    showTableTooltip: showTooltip,
    tableTooltipX: tooltipX,
    tableTooltipY: tooltipY,
    handleTableTooltipMouseMove: handleTooltipMouseMove,
    handleCellMouseEnter: handleTextMouseEnter,
    handleCellMouseLeave: handleTextMouseLeave,
  }
}
